import includes from 'ramda/es/includes'
import head from 'ramda/es/head'
import equals from 'ramda/es/equals'

const log = x => { console.warn(x); return x }

export default class DnDGroupSortValidator {
    static isAnswerCorrect(answer) {
        const userInput = head(answer.userInput())
        if(!userInput || !userInput.value)
            return false

        const answers           = userInput.value.answerData
        const expectedAnswers   = answer.correctAnswers()

        return expectedAnswers.map( (ea,i) => {
            const groupID = 'group_'+i
            return answers[groupID].map( a => includes(a, ea.elements))
                                   .every( equals(true) )
        })
        .every( equals(true) )
    }
}